<template>
    <b-modal
        :id="id"
        modal-class="modal-fullscreen"
        ref="gdprViewerModal"
        scrollable
        :title="title"
        body-class="pl-5 pr-5 h-100"
    >
        <div
            v-if="(!hasCustomGdpr && !hasTempGdpr) || isClientTerms"
            id="section-to-print"
            refs="print"
            v-html="gdpr"
        ></div>

        <div
            id="iframe-wrapper"
            v-if="(hasCustomGdpr || hasTempGdpr) && !isClientTerms"
            style="width:100%;height:100%;overflow:auto;-webkit-overflow-scrolling: touch;"
        >
            <embed
                :src="getDocumentUrlEndpoint()"
                type="application/pdf"
                width="100%"
                height="100%"
            >
        </div>

        <template #modal-footer>
            <div
                class="w-100"
                v-if="!hasCustomGdpr && !hasTempGdpr"
            >
                <b-button
                    variant="primary"
                    class="float-right"
                    @click="onPrint()"
                >
                    {{$t('Stampa')}}
                </b-button>
            </div>

            <div
                class="w-100"
                v-if="hasTempGdpr"
            >
                <b-button
                    variant="primary"
                    class="float-right"
                    @click="confirmGdpr"
                >
                    {{$t('Conferma')}}
                </b-button>
                <b-button
                    class="float-right"
                    @click="$refs.gdprViewerModal.hide()"
                >
                    {{$t('Annulla')}}
                </b-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: "GDPRViewer",
    props: [
        "gdpr",
        "title",
        "shop",
        "hasCustomGdpr",
        "hasTempGdpr",
        "isClientTerms"
    ],
    data() {
        return {
            id: null
        };
    },
    mounted() {
        this.id = "gdpr-viewer-" + this._uid;
    },
    methods: {
        onPrint() {
            this.$htmlToPaper("section-to-print");
        },
        getDocumentUrlEndpoint() {
            var statoDoc = this.hasTempGdpr ? "TEMPORANEO" : "CONFERMATO";
            var fkUtente = this.shop.fkUtente || this.shop.Fkutente;
            return (
                process.env.VUE_APP_API_BASE_URL +
                process.env.VUE_APP_API_UPLOAD_GDPR_ENDPOINT +
                "?fkUtenteFotografo=" +
                fkUtente +
                "&stato=" +
                statoDoc +
                "&uploadType=view"
            );
        },
        confirmGdpr() {
            this.$api
                .backendConfirmGdpr()
                .then((response) => {
                    console.debug("BACKEND_CONFIRM_GDPR", response);
                    this.$refs.gdprViewerModal.hide();
                    this.$emit("clearTemp");
                })
                .catch((error) => {
                    console.error("BACKEND_CONFIRM_GDPR", error);
                });
        }
    }
};
</script>

<style scoped>
div /deep/ .modal-fullscreen .modal-dialog {
    max-width: 90%;
    height: 90%;
}

div /deep/ .modal-fullscreen .modal-content {
    min-height: 100%;
    height: auto;
}

@media print {
    body * {
        visibility: hidden;
    }
    div#gdpr-wizard {
        display: none;
    }
    #section-to-print,
    #section-to-print * {
        visibility: visible;
    }
    #section-to-print {
        position: absolute;
        left: 0;
        top: 0;
    }
}
</style>
